module.exports = __webpack_public_path__ + "img/delpit.a2e584b4.png";